import { useStoredAttachmentSrc } from "@ext/agent/components/hooks/useStoredAttachmentSrc";
import { FileAttachmentTile } from "@ext/agent/components/panel/FileAttachmentTile";
import { ImageAttachmentPreview } from "@ext/agent/components/panel/ImageAttachmentPreview";
import type { StoredAttachment } from "@ext/agent/core/attachmentStore";

type Props = {
	attachment: StoredAttachment;
	onRemove: () => void;
};

export const DraftImageAttachment = ({ attachment, onRemove }: Props) => {
	const { src, failed } = useStoredAttachmentSrc(attachment);
	if (failed)
		return <FileAttachmentTile mime={attachment.mime} name={attachment.originalFilename} onRemove={onRemove} />;
	return <ImageAttachmentPreview name={attachment.originalFilename} onRemove={onRemove} src={src} />;
};
